<template>
    <BaseDropdown :leftMenu="true">
        <template v-slot:activator>
            <img :src="computeIconUrl">
            <template v-if="$isMobile()">
                <span style="padding: 10px">
                {{ computeCurrentName }}
                </span>
            </template>
        </template>

        <template v-slot:items>
            <DropdownItem v-for="lang in languages" @click="setLanguage(lang.code)" :key="lang.code">
                <span>
                    <img :src="`${publicPath}flagIcons/${lang.code}.png`" :key="lang.code" >
                </span>
                {{ lang.name }}
            </DropdownItem>
        </template>
    </BaseDropdown>
</template>

<script>
import DropdownItem from "./DropdownItem";
import { mapState } from 'vuex';
import BaseDropdown from "@/base/header/components/BaseDropdown";

export default {
    name: "Dropdown",
    components: {
        DropdownItem,
        BaseDropdown
    },
    methods: {
        setLanguage: function(code) {
            this.current = code;
        },
        load: function() {
            return localStorage.getItem('locale');
        },
        save: function() {
            localStorage.setItem('locale', this.current);
        }
    },
    computed: {
        current: {
            get() {
                return this.$i18n.locale;
            }, set(val) {
                this.$store.commit('setLocale', val)
                this.$i18n.locale = val;
                this.save();
            }
        },
        currentLanguage: function() {
            return this.languages.find(el => el.code === this.current);
        },
        computeIconUrl: function() {
            if (this.isUndefined(this.currentLanguage)) {
                return "";
            }
            return `${this.publicPath}flagIcons/${this.currentLanguage.code}.png`
        },
        computeCurrentName: function() {
            if (this.isUndefined(this.currentLanguage)) {
                return "";
            }
            return this.currentLanguage.name;
        },
        languages: function() {
            let fullNameLocale = {
                en: "English",
                de: "Deutsch",
                fr: "Français",
                it: "Italiano"
            }

            return this.$i18n.availableLocales.map(loc => {
                return {
                    code: loc,
                    name: fullNameLocale[loc]
                }
            });
        }
    },
    mounted() {
        let storage = this.load();
        
        let invalid = (storage === null || storage === undefined || storage === 'null');
        
        let code = invalid ? 'de' : storage;

        this.setLanguage(code);        
    },
    data() {
        return {
            publicPath: process.env.BASE_URL
        }
    }

}
</script>

<style lang="scss" scoped>

</style>